import { render } from "./HousingNew.vue?vue&type=template&id=93e78dd8"
import script from "./HousingNew.vue?vue&type=script&lang=js"
export * from "./HousingNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__